import fileDownload from 'js-file-download';
import axiosInstance from "../../../config/axios-config";

async function fetchAdminTeachersData(url, jwtToken, setTeachersData) {
  try {
    const response = await axiosInstance.get(url, {
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      },
    });
    
    const data = await response.data;

    await data.sort((teacher1, teacher2) => {
      const department1 = teacher1.department.toLowerCase();
      const department2 = teacher2.department.toLowerCase();

      if(department1 < department2) {
        return -1;
      }

      if(department1 > department2) {
        return 1;
      }

      const username1 = teacher1.username;
      const username2 = teacher2.username;

      return username1 - username2;
    });


    setTeachersData(data);
  } catch (err) {
    // console.error(err);
    setTeachersData([]);
  }
};

async function deleteTeacherByEmpNo(url, jwtToken, username, deleteTeacherFromList, toast) {
  if (!window.navigator.onLine) {
    toast.error("Could not delete the teacher, as your system has no internet connectivity. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });

    return;
  } 

  try {
    await axiosInstance.delete(url, {
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      },
    });
  
    await deleteTeacherFromList(username);
    
    toast.success(`Teacher with Emp No ${username} is successfully deleted.`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      }
    );          
  } catch (err) {
    if(err.response && err.response.status > 400) {
      toast.error("Could not delete the user, as it is an active user.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    }
  }
};

async function downloadTeachersDataCsv(url, jwtToken, filename, toast) {
  if (!window.navigator.onLine) {
    toast.error("Could not download the file, as your system has no internet connectivity. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });

    return;
  } 

  try {
    const response = await axiosInstance.get(url, {
      responseType: 'blob',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      },
    }); 
    const data = await response.data;

    await fileDownload(data, filename);

    toast.success(`Your file has been successfully downloaded.`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      }
    );
  } catch (err) {
    // console.error(err);
  }
};

async function uploadTeachersDataCsv(url, jwtToken, formData, toast) {
  await toast.promise(axiosInstance.post(url, formData, {
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        'content-type': 'multipart/form-data'
      }
    }),{
      pending: 'File upload is in progress.',
      success: 'File got successfully uploaded.',
      error: 'Error occured while uploading file. Please try again.'
    }
  )
};

export { fetchAdminTeachersData,  deleteTeacherByEmpNo, downloadTeachersDataCsv, uploadTeachersDataCsv };